var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_543_2344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#2483BC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_543_2344)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    fill: "#2483BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 4,
    height: 22,
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 4,
    height: 22,
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 4,
    height: 22,
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 4,
    height: 22,
    transform: "rotate(90 23 10)",
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 4,
    height: 22,
    transform: "rotate(90 23 10)",
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 4,
    height: 22,
    transform: "rotate(90 23 10)",
    fill: "#FFE14D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.733a843f862fb10024a4b5c9cb7e1379.svg";
export { ForwardRef as ReactComponent };